import { createAction, props } from '@ngrx/store'
import { ListingsValidationFieldResult } from '../rental-validation-field'
import { HopperStatus, HopperListingModel, HopperListingPayload } from './model'

export const GetHopperRentalValidations = createAction('[Hopper] Get Rental Validations')
export const GetHopperRentalValidationsSuccess = createAction(
  '[Hopper] Get Rental Validations Success',
  props<{
    validations: ListingsValidationFieldResult
  }>()
)

export const GetHopperStatus = createAction('[Hopper] Get Status')
export const GetHopperStatusSuccess = createAction('[Hopper] Get Status Success', props<{ status: HopperStatus }>())

export const ConnectHopper = createAction('[Hopper] Connect', props<{ email: string; name: string }>())
export const ConnectHopperSuccess = createAction('[Hopper] Connect Success')

export const DisconnectHopper = createAction('[Hopper] Disconnect')
export const DisconnectHopperSuccess = createAction('[Hopper] Disconnect Success')

export const GetHopperListings = createAction('[Hopper] Get Listings')
export const GetHopperListingsSuccess = createAction(
  '[Hopper] Get Listings Success',
  props<{ listings: HopperListingModel[] }>()
)

export const CreateHopperListing = createAction('[Hopper] Create Listing', props<{ listing: HopperListingPayload }>())
export const CreateHopperListingSuccess = createAction(
  '[Hopper] Create Listing Success',
  props<{ listing: HopperListingPayload }>()
)

export const UpdateHopperListing = createAction('[Hopper] Update Listing', props<{ listing: HopperListingPayload }>())
export const UpdateHopperListingSuccess = createAction(
  '[Hopper] Update Listing Success',
  props<{ listing: HopperListingPayload }>()
)

export const ActivateHopperListing = createAction(
  '[Hopper] Activate Listing',
  props<{ listingId: string; rentalId: string }>()
)
export const ActivateHopperListingSuccess = createAction(
  '[Hopper] Activate Listing Success',
  props<{ rentalId: string; active: boolean }>()
)

export const DeactivateHopperListing = createAction(
  '[Hopper] Deactivate Listing',
  props<{ listingId: string; rentalId: string }>()
)
export const DeactivateHopperListingSuccess = createAction(
  '[Hopper] Deactivate Listing Success',
  props<{ rentalId: string; active: boolean }>()
)

export const DeleteHopperListing = createAction('[Hopper] Delete Listing', props<{ rentalId: string }>())
export const DeleteHopperListingSuccess = createAction('[Hopper] Delete Listing Success', props<{ rentalId: string }>())
